import React from 'react';
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';

const LocationMap = withScriptjs(withGoogleMap(() => (
  <GoogleMap defaultZoom={14} defaultCenter={{ lat: 40.416790, lng: -86.857377 }}>
    <Marker position={{ lat: 40.416790, lng: -86.857377 }}/>
  </GoogleMap>
)));

export default LocationMap;



// WEBPACK FOOTER //
// ./src/components/StoreInfoPage/HoursAndLocation/LocationMap.js